<div class="dialog-content-wrapper" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragBoundary="body">
    <mat-toolbar [color]="'accent'" cdkDragHandle class="m-0"
             fxLayout="row" fxLayoutAlign="space-between center">
        <h2 mat-dialog-title class="title dialog-title m-0 p-0">{{ 'dialogs.dateRangePicker.title' | translate }}{{ (fromFieldOptional && toFieldOptional) ? ('dialogs.dateRangePicker.titleOptionalSuffix' | translate) : '' }}</h2>
            <button data-test="B-Close-dialog" mat-icon-button (click)="dialogRef.close(false)"
                    [attr.aria-label]="'common.closeDialogAria' | translate">
                <mat-icon>close</mat-icon>
            </button>
    </mat-toolbar>

    <div mat-dialog-content class="p-16 p-sm-24 m-0" fusePerfectScrollbar>

        <form [formGroup]="formGroup">

            <ng-container *ngIf="formGroup.errors">
                <u2b-message type="warning">
                    {{ formGroup.errors | firstErrorMessage }}
                </u2b-message>
            </ng-container>

            <ng-container *ngIf="optionalInfoText">
                <div class="mb-16">{{optionalInfoText}}</div>
            </ng-container>

            <div class="mb-16" *ngIf="types?.length">
                <mat-form-field appearance="outline" fxFlex="100"
                                floatLabel="always">
                    <mat-label>{{ 'dialogs.dateRangePicker.quickSelect' | translate }}</mat-label>
                    <mat-select (selectionChange)="setDates($event)" [ngModel]="defaultType"
                                [ngModelOptions]="{standalone: true}">
                        <ng-container *ngFor="let type of types">
                            <mat-option [value]="type">{{ presetTranslationKey(type) | translate }}</mat-option>
                        </ng-container>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="input-row"
                 fxLayout="row wrap"
                 fxLayoutGap="12px grid">

                <mat-form-field fxFlex="50" appearance="outline" floatLabel="always">
                    <mat-label>{{ 'dialogs.dateRangePicker.labelFrom' | translate }}</mat-label>
                    <input matInput data-test="FI-von" formControlName="from"
                           appMaskDate [placeholder]="'common.dateRange.datePlaceholder' | translate"
                           [matDatepicker]="fromDatePicker"
                           [max]="fromDateMax">
                    <mat-datepicker-toggle data-test="FIT-von" matSuffix
                                           [for]="fromDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #fromDatePicker></mat-datepicker>
                    <mat-error>{{ formGroup.get('from').errors | firstErrorMessage }}</mat-error>
                </mat-form-field>

                <mat-form-field fxFlex="50" appearance="outline" floatLabel="always">
                    <mat-label>{{ 'dialogs.dateRangePicker.labelTo' | translate }}</mat-label>
                    <input matInput data-test="FI-bis" formControlName="to"
                           appMaskDate [placeholder]="'common.dateRange.datePlaceholder' | translate"
                           [matDatepicker]="untilDatePicker"
                           [max]="toDateMax">
                    <mat-datepicker-toggle data-test="FIT-bis" matSuffix
                                           [for]="untilDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #untilDatePicker></mat-datepicker>
                    <mat-error>{{ formGroup.get('to').errors | firstErrorMessage }}</mat-error>
                </mat-form-field>
            </div>

            <div class="input-row">
                <ng-container *ngIf="orderByFilters?.length">
                    <mat-form-field fxFlex="100" appearance="outline" floatLabel="always">
                        <mat-label>{{ 'dialogs.dateRangePicker.sortBy' | translate }}</mat-label>
                        <mat-select formControlName="orderBy">
                            <ng-container *ngFor="let item of orderByFilters">
                                <mat-option [value]="item.orderBy">{{ item.label }}</mat-option>
                            </ng-container>
                        </mat-select>
                        <mat-error>{{ formGroup.get('orderBy').errors | firstErrorMessage }}</mat-error>
                    </mat-form-field>
                </ng-container>
            </div>
        </form>

    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="space-between center">
        <button data-test="B-Abbrechen" mat-button
                (click)="dialogRef.close(false)"
                [attr.aria-label]="'common.closeDialogAria' | translate">
            <mat-icon>cancel</mat-icon>
            {{ 'common.cancel' | translate }}
        </button>
        <button data-test="B-Speichern" mat-flat-button
                color="accent"
                (click)="save()"
                class="save-button mat-accent"
                [attr.aria-label]="'common.save' | translate">
            {{ 'dialogs.dateRangePicker.next' | translate }}
            <mat-icon>keyboard_arrow_right</mat-icon>
        </button>
    </div>
</div>
